import BanzaiBooksService from '@/services/banzai-books.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiBooks = new BanzaiBooksService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiBooks: BanzaiBooksService;
  }
}
